var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_46787",
    "data-name": "Group 46787",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.18,
    height: 55.18,
    viewBox: "0 0 55.18 55.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_197109",
    "data-name": "Path 197109",
    d: "M0,0H55.18V55.18H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_197110",
    "data-name": "Path 197110",
    d: "M42.479,10.886A1.868,1.868,0,0,0,41.24,9.525c-1-.283-5.9-.927-16.248-.927s-15.239.644-16.253.927A1.871,1.871,0,0,0,7.5,10.886,57.392,57.392,0,0,0,6.6,22.393,57.469,57.469,0,0,0,7.5,33.9a1.862,1.862,0,0,0,1.237,1.357c1.012.285,5.9.929,16.25.929s15.241-.644,16.253-.927A1.871,1.871,0,0,0,42.479,33.9a57.48,57.48,0,0,0,.906-11.507A57.5,57.5,0,0,0,42.479,10.886Zm4.453-1.143c1.051,4.1,1.051,12.65,1.051,12.65s0,8.553-1.051,12.65a6.463,6.463,0,0,1-4.456,4.649c-3.929,1.094-17.485,1.094-17.485,1.094s-13.549,0-17.485-1.094a6.462,6.462,0,0,1-4.456-4.649C2,30.946,2,22.393,2,22.393S2,13.84,3.051,9.743A6.463,6.463,0,0,1,7.506,5.094C11.443,4,24.992,4,24.992,4S38.548,4,42.477,5.094a6.462,6.462,0,0,1,4.456,4.649ZM20.393,30.44V14.346l13.795,8.047Z",
    transform: "translate(2.598 5.197)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.2a8aecd656e86879738fe045290b6f9c.svg";
export { ForwardRef as ReactComponent };